export class SessionService {
  static USER_ID_KEY = "rag_user_id";
  static SESSION_ID_KEY = "rag_session_id";
  static SESSION_TIMESTAMP_KEY = "rag_session_timestamp";
  
 
  private static generateUUID(): string {
    if (window.crypto && window.crypto.randomUUID) {
      try {
        return window.crypto.randomUUID();
      } catch (error) {
        console.error("Crypto API error:", error);
      }
    }

    const timestamp = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (timestamp + Math.random() * 16) % 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  static getUserId(): string {
    let userId = localStorage.getItem(this.USER_ID_KEY);
    if (!userId) {
      userId = this.generateUUID();
      localStorage.setItem(this.USER_ID_KEY, userId);
      return userId;
    }
    return userId as string;
  }

  static getSessionId(): string {
    let sessionId = sessionStorage.getItem(this.SESSION_ID_KEY);
    const sessionTimestamp = sessionStorage.getItem(this.SESSION_TIMESTAMP_KEY);
    const currentTime = Date.now();
    
    // Create new session if Session ID doesn't exist or 30 minutes have passed
    if (!sessionId || !sessionTimestamp || (currentTime - parseInt(sessionTimestamp)) > 30*60*1000) {
      sessionId = this.generateUUID();
      sessionStorage.setItem(this.SESSION_ID_KEY, sessionId);
      sessionStorage.setItem(this.SESSION_TIMESTAMP_KEY, currentTime.toString());
      console.log("[SessionService] New session ID created:", sessionId);
      return sessionId;
    }
    
    // Timestamp is updated on each getSessionId call, so session continues during active use
    sessionStorage.setItem(this.SESSION_TIMESTAMP_KEY, currentTime.toString());
    
    return sessionId as string;
  }

  static resetSessionId(): void {
    const newSessionId = this.generateUUID();
    const oldSessionId = sessionStorage.getItem(this.SESSION_ID_KEY);
    sessionStorage.setItem(this.SESSION_ID_KEY, newSessionId);
    sessionStorage.setItem(this.SESSION_TIMESTAMP_KEY, Date.now().toString());
    console.log("[SessionService] Session ID reset:", oldSessionId, "->", newSessionId);
  }
  
}
